import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Route, RouteControllerService } from '@api/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStoreFeature, type, withMethods, withProps, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { NotificationService } from '@shared/services/notifications/notifications.service';
import { pipe, switchMap } from 'rxjs';

export const useRoutes = () =>
  signalStoreFeature(
    {
      props: {
        _notificationService: type<NotificationService>(),
      },
    },
    withState({
      routes: new Array<Route>(),
    }),
    withProps(() => ({
      _routesService: inject(RouteControllerService),
    })),
    withMethods(store => {
      const loadRoutes = rxMethod<number>(
        pipe(
          switchMap((accountId: number) =>
            store._routesService.getDirectRoutes({ accountId }).pipe(
              tapResponse({
                next: (routes: Route[]) => {
                  patchState(store, { routes });
                },
                error: (error: HttpErrorResponse) => {
                  store._notificationService.showErrorNotification('Failed to load routes', error);
                },
              }),
            ),
          ),
        ),
      );

      return {
        loadRoutes,
      };
    }),
  );
